/*
Scroll-tied color transition — sweeps text color word by word (left to
right, line by line) from its current/default color to the color
referenced by data-transition-color. Elements passed in together are
chained on a single timeline so one finishes before the next begins.
*/

export function initColorTransitionGroup(elements, { gsap, SplitText }) {
    const isReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const targets = [...elements]
        .map((el) => ({
            el,
            startColor: getComputedStyle(el).color,
            targetColor: getComputedStyle(document.documentElement)
                .getPropertyValue(`--color-${el.dataset.transitionColor}`)
                .trim(),
        }))
        .filter(({ targetColor }) => targetColor);

    if (!targets.length) return;

    // reduced motion: snap straight to each final state instead of animating on scroll
    if (isReduced) {
        targets.forEach(({ el, targetColor }) => {
            el.style.color = targetColor;
        });
        return;
    }

    const timeline = gsap.timeline({
        scrollTrigger: {
            trigger: targets[0].el,
            start: 'top 55%',
            endTrigger: targets[targets.length - 1].el,
            end: 'center center',
            scrub: true,
        },
    });

    // walked forward as each tween is added so the next one starts only once
    // the previous element has fully finished, regardless of its char count
    let cursor = 0;

    targets.forEach(({ el, startColor, targetColor }) => {
        const position = cursor;

        SplitText.create(el, {
            type: 'lines, words, chars',
            autoSplit: true, // re-splits on resize/font load so the sweep stays accurate
            onSplit(self) {
                // short duration relative to stagger keeps each char's flip crisp
                // instead of blending into a smooth wash across the line
                const tween = gsap.fromTo(
                    self.chars,
                    { color: startColor },
                    { color: targetColor, ease: 'none', duration: 0.3, stagger: 0.015 }
                );
                timeline.add(tween, position);
                cursor = position + tween.duration();
                return tween;
            },
        });
    });
}


